// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"wP-z","inlineTitle":"xP-z","sponsoredAdsWrapper":"yP-z","marketplaceRecosWrapper":"zP-z"};